import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><path d=\"M469.333333 469.333333v-256h85.333334v256h256v85.333334h-256v256h-85.333334v-256h-256v-85.333334z\" fill=\"#FAFAFA\" p-id=\"1697\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol